import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_JOB_SAVED } from "../../../common/URLs";

export const fetchSavedJobs = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_JOB_SAVED}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};


export const saveJobApi = async ( job_uuid, status ) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_JOB_SAVED}`; // Update with the correct endpoint
  
  try {
    const token = await fetchToken()
    const requestData = { job_uuid, status }; // Structure your payload
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, 
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error('Failed to save job');
    }

    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
